import { DownloadOutlined } from '@ant-design/icons';
import { Table } from 'antd';
import moment from 'moment';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useContactStore } from '../../hooks/useContactStore';
import { apiInstance } from '../../utils/api';
import { downloadFile } from '../../utils/urlImgToBlob';

const ExpandableText = ({ text }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div
      className={`expandable-text f16-grey-dark ${
        isExpanded ? 'expandable-text--expanded' : 'expandable-text--collapsed'
      }`}
      onMouseEnter={() => setIsExpanded(true)}
      onMouseLeave={() => setIsExpanded(false)}
    >
      {text}
    </div>
  );
};

const columns = [
  {
    title: 'Дата рахунку',
    dataIndex: 'date',
    className: 'date center',
    width: 150,
  },
  {
    title: 'Дата платежу',
    dataIndex: 'RespDateOfHolding',
    className: 'date center',
    width: 150,
  },
  {
    title: 'Призначення платежу',
    dataIndex: 'purposeOfPayment',
    className: 'purpose-of-payment',
    width: 480,
  },
  {
    title: 'Номер рахунку',
    dataIndex: 'accountNumber',
    className: 'account-number center',
    render: (text, record) => {
      if (record.fileId) {
        return (
          <div
            onClick={() => record.download(record.fileId)}
            style={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 8 }}
            className="f16-black link-download"
          >
            <span style={{ textDecoration: 'underline', color: '#1890ff' }}>{text}</span>
            <DownloadOutlined style={{ fontSize: 16, color: '#1890ff' }} />
          </div>
        );
      }
      return <div className="f16-grey-dark">{text}</div>;
    },
  },
  {
    title: 'Сума',
    dataIndex: 'amount',
    className: 'amount-sum center',
  },
  {
    title: 'Статус',
    dataIndex: 'status',
    className: 'status center',
  },
];

const AccountTable = () => {
  const { currentContactStore } = useContactStore();
  const [counterparty, setCounterparty] = useState([]);

  // removed unused SuPurposeOfPayment constant

  const ROUTES = {
    COUNTERPARTY: `${process.env.REACT_APP_API_URL}/api/crm/get-data?type=requestInvoice`,
  };

  useEffect(() => {
    apiInstance(ROUTES.COUNTERPARTY, 'GET')
      .then((res) => setCounterparty(res.rows))
      .catch((error) => console.log(error));
    // ROUTES is static inside component scope; eslint exhaustive-deps not needed
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentContactStore]);

  const download = useCallback((id) => {
    const ROUTES = {
      FILE: new URL(`${process.env.REACT_APP_API_URL}/api/files?fileId=${id}&type=receipt`),
    };
    return downloadFile(ROUTES.FILE);
  }, []);

  const prepareRequestData = useMemo(() => {
    return counterparty
      .filter(({ Number }) => !(typeof Number === 'string' && Number.startsWith('INV')))
      .map(
        ({
          StartDate,
          RespDateOfHolding,
          Amount,
          FileId,
          RespPurposeOfPayment,
          Number,
          PaymentStatus,
        }) => ({
          date: (
            <div className="f16-grey-dark">
              <div>{moment(StartDate).format('DD.MM.YYYY')}</div>
            </div>
          ),
          RespDateOfHolding: (
            <div className="f16-grey-dark">
              <div>
                {moment(RespDateOfHolding).isValid() && RespDateOfHolding
                  ? moment(RespDateOfHolding).format('DD.MM.YYYY')
                  : '-'}
              </div>
            </div>
          ),
          purposeOfPayment: (
            <ExpandableText text={RespPurposeOfPayment.length > 0 ? RespPurposeOfPayment : '-'} />
          ),
          accountNumber: Number,
          amount: <div className="f16-black">{Amount.toFixed(2)} грн</div>,
          fileId: FileId,
          download: download,
          status: <div>{PaymentStatus.displayValue}</div>,
        })
      );
  }, [counterparty, download]);

  return (
    <Table
      className="default-table account-table request-table"
      columns={columns}
      dataSource={prepareRequestData}
      locale={{ emptyText: 'Ще немає даних для відображення' }}
    />
  );
};

export default AccountTable;
